angular.module('tf.services')

    .factory('TourService', [function(){
        var service = {};

        var theme = 'shepherd-theme-arrows';

        var projectTour;

        projectTour = new Shepherd.Tour({
            defaults: {
                classes: 'shepherd-theme-arrows',
                scrollTo: false
            }
        });

        projectTour.addStep('first',{
                title : 'This is en element',
                text: 'this is an explanation about the element',
                attachTo: '.project-menu bottom',
                classes: theme,
                showCancelLink : true,
                buttons: [
                    {
                        text: 'Next',
                        action: projectTour.next
                    }
                ]
            }
        );
        projectTour.addStep('second',{
                title : 'This is en element',
                text: 'this is an explanation about the element',
                attachTo: '.project-template-single-ui-controls right',
                classes: theme,
                showCancelLink : true,
                buttons: [
                    {
                        text: 'Next',
                        action: projectTour.next
                    }
                ]
            }
        );
        projectTour.addStep('third',{
                title : 'This is en element',
                text: 'this is an explanation about the element',
                attachTo: '.project-template-single-ui-preview left',
                classes: theme,
                showCancelLink : true,
                buttons: [
                    {
                        text: 'Next',
                        action: projectTour.next
                    }
                ]
            }
        );
        projectTour.addStep('fourth',{
                title : 'This is en element',
                text: 'this is an explanation about the element',
                attachTo: '.templates-selector top',
                classes: theme,
                showCancelLink : true,
                buttons: [
                    {
                        text: 'Next',
                        action: projectTour.next
                    }
                ]
            }
        );

        var tour = new Tour({
            storage : false,
            backdrop : true,
            steps: [
                {
                    element: ".project-menu",
                    title: "Title of my step",
                    content: "Content of my step",
                    placement : 'bottom'
                },
                {
                    element: ".project-template-single-ui-controls",
                    title: "Title of my step",
                    content: "Content of my step",
                    placement : 'right'
                },
                {
                    element: ".project-template-single-ui-preview",
                    title: "Title of my step",
                    content: "Content of my step",
                    placement : 'left'
                },
                {
                    element: ".templates-menu",
                    title: "Title of my step",
                    content: "Content of my step",
                    placement : 'top',
                    backdrop : false
                }
            ]});




        service.runProjectTour = function(){
            //projectTour.start();

            tour.init();
            tour.start();
        };

        return service;
    }])
;
